import reducer from "./reducers";
import { routes } from "../routes";
import * as userManagementOperations from "./operations";
import selectors from "./selectors";

export {
    userManagementOperations,
    selectors
};

export default {
    reducer,
    routes
};
